<div class="surcharges">
  <div
    class="row mb-4 ps-4"
    *ngIf="!hideHeaders"
  >
    <div class="col-5">
      <span class="fw-bold">{{ 'surcharges.type' | translate }}</span>
    </div>
    <div class="col-7 ps-0">
      <span class="fw-bold">{{ 'surcharges.list' | translate }}</span>
    </div>
  </div>
  <div
    class="row teaser bg-lightest"
    *ngFor="let surcharge of surcharges"
  >
    <div class="col-5">
      <span class="fw-medium">{{ 'days.' + surcharge?.type | translate }}</span>
    </div>
    <div class="col-5">
      <span>{{ surcharge?.fromTime }} - {{ surcharge?.toTime }} {{ 'dateTime.hour' | translate }}</span>
    </div>
    <div class="col-2 text-end">
      <span>{{ surcharge?.rate }}%</span>
    </div>
  </div>
  <base-empty-list-row
    *ngIf="surcharges?.length === 0"
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
    message="surcharges.emptyList"
  ></base-empty-list-row>
</div>
